
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[comicId]",
      function () {
        return require("private-next-pages/content/[comicId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/[comicId]"])
      });
    }
  